import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';

import { Button } from './Button';

import { Wrap } from './Wrap';
import { TranslateModule } from "@ngx-translate/core";
import { ChevronRight } from "./svg/ChevronRight";

@Component({
  selector: 'InstallFooter',
  imports: [Button, TranslateModule, Wrap, ChevronRight],
  template: `
    <div class="h-32 lg:h-12 w-full bg-blue-50"></div>
    <div class="w-full fixed bottom-0 left-0 z-10 bg-white">
      <div class="bg-blue-100 h-1">
        <div
            class="h-full w-full bg-blue-500 origin-left transition-transform duration-200 ease-out"
            style="transform: scaleX({{ scrollPercentage() }}%);"
        ></div>
      </div>

      <Wrap [class]="'center py-4'">
        @if (!showDashboardButton()) {
          <Button
              [color]="'blue'"
              (click)="scrollTo('save-more-time')">
            {{ 'INCLUDE_INSTALLFOOTER_BUTTON_CONTINUE' | translate }}
            <ChevronRight />
          </Button>
        } @else {
          <Button
              [color]="'blue'"
              [href]="'/dashboard'">
            {{ 'INCLUDE_INSTALLFOOTER_BUTTON_DASHBOARD' | translate }}
          </Button>
        }
      </Wrap>
    </div>
  `
})
export class InstallFooter implements OnInit {
  // signals, because they are updated from a native scroll listener that Angular does not know about
  readonly scrollPercentage = signal(0);
  readonly showDashboardButton = signal(false);

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    const listener = () => requestAnimationFrame(this.onScroll);
    window.addEventListener('scroll', listener, true);
    this.destroyRef.onDestroy(() => window.removeEventListener('scroll', listener, true));
  }

  onScroll = () => {
    // Calculate scroll percentage
    const height = document.documentElement.scrollHeight - window.innerHeight;
    this.scrollPercentage.set((window.scrollY / height) * 100);

    // Show dashboard button after scrolling
    if (!this.showDashboardButton() && window.scrollY > 300) {
      this.showDashboardButton.set(true);
    }
  }

  scrollTo = (id: string) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/dashboard';
    }
  };
}
